// extracted by mini-css-extract-plugin
module.exports = {"btn":"style__btn__-HDhe","btn-secondary":"style__btn-secondary__ibd2R","active":"style__active__dI9hJ","wrapper":"style__wrapper__5wU7Y","logo":"style__logo__PgcIE"};